export enum IncentiveScrappingFilterValue {
  Off = 0,
  On = 1,
}
